import React from 'react';
import PublicHeader from '../Header/PublicHeader';
import Footer from '../Footer';

const Governance = () => {
  return (
    <>
    <div>
      <PublicHeader/>
      <iframe
        src="https://www.edrawmind.com/app/editor/sFcUbqRjHTkusbVXNkEbCFnmQYHvU800?share=1&page=8889934692"
        width="100%"
        height="600px"
        style={{ border: 'none' }}
        title="Governance Document"
      ></iframe>
    </div>
    <Footer />
    </>
  );
};

export default Governance;